import { render, staticRenderFns } from "./ProfilePasswordChange.vue?vue&type=template&id=3c5a0971&"
import script from "./ProfilePasswordChange.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports